module.exports = __webpack_public_path__ + "static/media/dice-five.3eeb80e1.svg";